import { useRef } from 'react'
import { motion, useInView } from 'framer-motion'

export default function FinalSection() {
  const sectionRef = useRef(null)
  const isInView = useInView(sectionRef, { once: true, margin: '-100px' })

  return (
    <section
      ref={sectionRef}
      className="relative w-full py-24 md:py-32 px-4"
      style={{ background: '#050510' }}
    >
      {/* Background glow */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background: 'radial-gradient(ellipse at 50% 50%, rgba(139,92,246,0.08) 0%, transparent 60%)',
        }}
      />

      <div className="max-w-3xl mx-auto text-center relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
        >
          <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-bold text-nerd-white mb-4">
            Non devi smettere di essere{' '}
            <span className="text-gradient">nerd.</span>
          </h2>

          <p className="text-nerd-gray text-base md:text-lg mb-10">
            Devi smettere di usare quel mondo per sparire.
          </p>

          <a href="#percorso" className="nerd-btn-primary inline-block text-sm">
            Inizia la tua quest
          </a>
        </motion.div>
      </div>
    </section>
  )
}
